import { makeGet, makeRequest } from '@monjin/data';
import { fetchBody } from '@monjin/data/util';

import { InterviewData, UserData } from '../model/invitation';

export function findInvitation(inviteCode: string): Promise<UserData> {

    const url = `/api/invitations/${inviteCode}`;

    return fetchBody(makeGet(url))
        .then(parseUserInfo);
}

export function claimInvitation(inviteCode: string): Promise<InterviewData> {

    const url = `/api/claim_invitation/${inviteCode}`;

    return fetchBody(makeRequest('POST', url, {}))
        .then(parseClaimInvitation);
}

export function claimInterestCheckInvitation(inviteId: number): Promise<any> {

    const url = `/_/a/22/1/1/1051/cnd/InterestCheck`;

    return fetchBody(makeRequest('POST', url, { inviteId }));
}

export function consumeParticipantCode(participantCode: string): Promise<number> {

    const url = `/api/participants/${participantCode}`;
    const body = {};

    return fetchBody(makeRequest('POST', url, body))
        .then((x: any) => x.videoActivityId as number);
}

export function getParticipantUserId(participantCode: string): Promise<number> {

    const url = `/api/participants/${participantCode}`;

    return fetchBody(makeGet(url))
        .then((x: any) => x.userId);
}

export function findYCOIInvite(inviteCode: string): Promise<any> {

    const url = `/api/invite/ycoi/${inviteCode}`;

    return fetchBody(makeGet(url));
}

export function fetchInviteDetails(userId: number, inviteId: number): Promise<any> {
    const url = `/_/a/22/1/1/${userId}/cnd/JdInvite/${inviteId}`;

    return fetchBody(makeGet(url));
}

export function updateInviteStatus(apexId: number, userId: number, inviteId: number): Promise<any> {
    const url = `/_/a/22/${apexId}/1/${userId}/cnd/invite`;

    const payload = {
        id: inviteId,
        inviteStatus: 'accepted'
    };

    const request = makeRequest('PATCH', url, payload);

    return fetchBody(request);
}

export function applyAgainstJD(apexId: number, userId: number, payload): Promise<number> {
    const url = `/_/a/22/${apexId}/1/${userId}/cnd/invite`;

    const request = makeRequest('POST', url, payload);

    return fetchBody(request)
        .then((response) => response.id);
}

function parseClaimInvitation(response: any): InterviewData {
    return {
        firstName: response.firstName,
        lastName: response.lastName,
        tenantName: response.apexName,
        tenantLogo: response.apexLogo,
        videoActivityId: response.videoActivityId,
        interviewId: response.interviewId,
        inviteCode: response.inviteCode,
        hasAcceptedTAndC: response.hasAcceptedTAndC,
        departmentId: response.departmentId,
        participantCode: response.participantCode
    };
}

function parseUserInfo(response: any): UserData {
    return {
        firstName: response.firstName,
        lastName: response.lastName,
        email: response.email,
        jDId: response.jobDescriptionId,
        tenantId: response.publisherId,
        tenantVersion: response.publisherVersion,
        departmentId: response.departmentId,
        tenantName: response.apexName,
        tenantLogo: response.apexLogo,
        userId: response.userId,
        isInterestCheckInvite: response.isInterestCheckInvite,
        inviteId: response.inviteId,
        canContinueOnMobile: response.canContinueOnMobile,
        monochrome: response.isLogoMonochrome
    };
}
